import { createPortal } from "react-dom";

// Renderiza su contenido directamente en <body>, fuera del área scrolleable
// del dashboard. Así los overlays `fixed` cubren TODA la ventana (incluida la
// barra superior) y no quedan atrapados por el contenedor de contenido.
export default function ModalPortal({ children }) {
  if (typeof document === "undefined") return null;
  return createPortal(children, document.body);
}
